import { lazy, Suspense } from "react";
import type { SlotEntry } from "@saas/ui";
const CaseProjectsPanel = lazy(
  () => import("./components/CaseProjectsPanel.js"),
);
export const taskSlots: SlotEntry[] = [
  {
    id: "task.case-projects",
    module: "task",
    slot: "project.tasks",
    subjectTypes: ["project"],
    permission: ["task.board.read"],
    Component: (props) => (
      <Suspense fallback={<p>プロジェクトを読み込んでいます…</p>}>
        <CaseProjectsPanel {...props} />
      </Suspense>
    ),
  },
];
